import {
  FlowChartBlock,
  FlowChartBlockType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { FlowChartImagePreview } from 'common/builder/components/chart/FlowChart/types/FlowChartImagePreview'

export enum CardAspectRatio {
  SQUARE = 'square',
  LANDSCAPE = 'landscape',
}

export enum CardImageType {
  PREVIEW = 'preview',
  EXTERNAL = 'external',
}

export interface CardImagePreview {
  type: CardImageType.PREVIEW
  preview: FlowChartImagePreview
}

export interface CardImageExternal {
  type: CardImageType.EXTERNAL
  url: string
}

export type FlowChartCardImage = CardImageExternal | CardImagePreview | null

export interface FlowChartCard {
  id: string
  title: string
  isHidden: boolean
  subTitle: string
  url: string | null
  aspectRatio: CardAspectRatio
  image: FlowChartCardImage
  buttons: FlowChartButton[]
}

export interface FlowChartCardsBlock extends FlowChartBlock {
  type: FlowChartBlockType
  data: {
    cards: FlowChartCard[]
  }
}
